import {
  List,
  Datagrid,
  TextField,
  SimpleList,
  EditButton,
  TextInput,
  ReferenceField,
  ListActions,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
  ShowButton,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT } from "utils/constants";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { administrationRequests } from "api/administrationApi";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import { specialistRequests } from "api/specialistApi";
import { MobileListRow } from "features/MobileListRow";
import { settings } from "app";
import { EmptyList } from "server/components";

const filters = [
  <ReferenceInput
    source="departmentId"
    reference={administrationRequests.getDepartmentsSelect()}
    alwaysOn
    filter={{ filterByUser: true }}
  >
    <AutocompleteInput
      optionText="name"
      label="Катедра"
      fullWidth
      filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
      style={{ width: 300 }}
    />
  </ReferenceInput>,
  <TextInput
    source="name"
    label="Име"
    alwaysOn
  />,
  <ReferenceInput
    source="laborCategory"
    reference={specialistRequests.getSpecializationLaborCategoriesSelect()}
    alwaysOn
  >
    <SelectInput
      optionText="nameBg"
      label="Категория труд"
    />
  </ReferenceInput>,
];

const ListSpecializations = () => {
  const isSmall = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      filters={filters}
      exporter={false}
      actions={<ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageSpecializations)} />}
    >
      {isSmall ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              fields={[
                {
                  label: "Име на български език",
                  value: record.nameBg,
                },
              ]}
            />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Име на английски език",
                    value: (
                      <TextField
                        source="nameEn"
                        label="Име на английски език"
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow fields={[{ label: "Код", value: record.code }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Категория",
                    value: (
                      <ReferenceField
                        source="laborCategory"
                        reference={specialistRequests.getSpecializationLaborCategoriesSelect()}
                        label="Категория"
                        sortable={false}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Тип",
                    value: (
                      <ReferenceField
                        source="type"
                        reference={specialistRequests.getSpecializationTypesSelect()}
                        label="Тип"
                        sortable={false}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Катедра",
                    value: (
                      <ReferenceField
                        source="departmentId"
                        reference={administrationRequests.getDepartmentsSelect()}
                        label="Катедра"
                        sortable={false}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canManageSpecializations}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canManageSpecializations}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
          />
          <TextField
            source="code"
            label="Код"
          />
          <ReferenceField
            source="laborCategory"
            reference={specialistRequests.getSpecializationLaborCategoriesSelect()}
            label="Категория"
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <ReferenceField
            source="type"
            reference={specialistRequests.getSpecializationTypesSelect()}
            label="Тип"
            sortable={false}
          >
            <TextField source="nameBg" />
          </ReferenceField>
          <ReferenceField
            source="departmentId"
            reference={administrationRequests.getDepartmentsSelect()}
            label="Катедра"
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>

          <SecuredComponent permission={permissions.canManageSpecializations}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canManageSpecializations}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListSpecializations;
